import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Route, Switch } from 'react-router-dom';
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from './configs/AppConfig';
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import SplashScreen from 'components/shared-components/SplashScreen';
import SessionGate from 'auth/SessionGate';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  const queryClient = new QueryClient()

  return (
    <div className="App">
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <PersistGate loading={<SplashScreen />} persistor={persistor}>
            <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
              <SessionGate>
                <Router>
                  <Switch>
                    <Route path="/" component={Views} />
                  </Switch>
                </Router>
              </SessionGate>
            </ThemeSwitcherProvider>
          </PersistGate>
        </QueryClientProvider>
      </Provider>
    </div>
  );
}

export default App;
